import React from "react";

import imagePlaceholder from "shared/resources/thumbnail-product-placeholder.png";
import startupsApiRoutes from "startups/apiRoutes";
import merchantsApiRoutes from "merchants/apiRoutes";
import axios from "axios";
import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";

import { Button } from "react-bootstrap";

export default class ImageUpload extends React.Component {
  handleRemoveNew(e) {
    e.preventDefault();
    this.props.onChange(null);
  }

  handleRemoveSaved(e) {
    e.preventDefault();
    this.props.onChange({
      target: {
        value: {
          remove: true,
        },
      },
    });
  }

  handleChange(e) {
    e.preventDefault();

    this.props.toggleSubmit(true);

    const file = e.target.files[0];

    if (!file) {
      this.props.onChange(null);
      return;
    }

    this.props.onChange({
      target: {
        value: {
          preview: URL.createObjectURL(file),
          file,
          uploaded: false,
        },
      },
    });

    this.directUpload(file)
      .then(uploadResponse => {
        this.props.onChange({
          target: {
            value: {
              ...this.props.value,
              uploadResponse,
              uploaded: true,
            },
          },
        });
        this.props.toggleSubmit(false);
      })
      .catch(() => {
        this.props.onChange({
          target: {
            value: {
              uploaded: false,
              uploadError: true,
            },
          },
        });
      });
  }

  directUpload(file) {
    return this.directUploadS3(file);
  }

  directUploadS3(file) {
    return new Promise((resolve, reject) => {
      const uppy = new Uppy({
        autoProceed: true,
      }).use(AwsS3, {
        getUploadParameters: () => {
          return axios
            .get(
              `${(this.props.startups
                ? startupsApiRoutes
                : merchantsApiRoutes
              ).uploadPresignPath()}?filename=${encodeURIComponent(file.name)}`,
            )
            .then(res => {
              return res.data;
            })
            .catch(() => {
              reject();
            });
        },
      });

      uppy.addFile({
        name: file.name,
        type: file.type,
        data: file,
      });

      uppy.on("upload-success", uploadedFile => {
        const id = this.extractIdFromUploadedFileS3(uploadedFile);

        resolve(
          // This is serialized JSON by purpose: backend receives it as JSON string
          JSON.stringify({
            id,
            storage: "cache",
            metadata: {
              size: uploadedFile.size,
              filename: uploadedFile.name,
              mime_type: uploadedFile.type,
            },
          }),
        );
      });

      uppy.on("upload-error", () => {
        reject();
      });

      uppy.on("error", () => {
        reject();
      });
    });
  }

  extractIdFromUploadedFileS3(uploadedFile) {
    // remove the Shrine storage prefix
    return uploadedFile.meta.key.match(/^cache\/(.+)/)[1];
  }

  // Note: Uses children as placeholder when no value is set
  render() {
    const { props } = this;
    const { name, value, hasAServerValue, children, merchants, startups } =
      props;
    if (!merchants && !startups) {
      return null;
    }

    const imageSelect = (
      <label
        id={`label-image-upload-button-${name}`}
        className="btn btn-default"
        htmlFor={`image-upload-button-${name}`}
      >
        <input
          type="file"
          id={`image-upload-button-${name}`}
          style={{ display: "none" }}
          onChange={this.handleChange.bind(this)}
          ref={i => {
            this.fileUploadInput = i;
          }}
        />
        Neues Bild festlegen…
      </label>
    );

    return (
      <div className={`image-upload image-upload-${name}`}>
        <Choose>
          <When condition={value && value.preview}>
            <div className="image-upload-preview image-upload-thumbnail">
              <img src={value.preview} alt="preview" />
            </div>
          </When>
          <When condition={value && value.remove}>
            <div className="image-upload-preview image-upload-thumbnail">
              <img src={imagePlaceholder} alt="will be removed" />
            </div>
          </When>
          <Otherwise>{children}</Otherwise>
        </Choose>

        <div className="image-upload-interface">
          <Choose>
            <When
              condition={
                value && value.uploaded === false && !value.uploadError
              }
            >
              Bild wird hochgeladen…
            </When>
            <When
              condition={value && value.uploaded === false && value.uploadError}
            >
              <div>
                Bild-Upload fehlgeschlagen. Bitte erneut versuchen!
                <br />
                <br />
                {imageSelect}
              </div>
            </When>
            <When condition={value && value.preview}>
              <Button onClick={this.handleRemoveNew.bind(this)}>
                Neu ausgewähltes Bild entfernen
              </Button>
            </When>
            <When condition={value && value.remove}>
              <div>
                <Button onClick={this.handleRemoveNew.bind(this)}>
                  Gespeichertes Bild doch nicht entfernen
                </Button>
                {imageSelect}
              </div>
            </When>
            <When condition={hasAServerValue && !(value && value.remove)}>
              <div>
                <Button onClick={this.handleRemoveSaved.bind(this)}>
                  Gespeichertes Bild entfernen
                </Button>
                {imageSelect}
              </div>
            </When>
            <Otherwise>{imageSelect}</Otherwise>
          </Choose>
        </div>
      </div>
    );
  }
}
